import {SureFlowLoopDetail} from './sure-flow-loop-detail';

export class EntitySureFlowLoop {

  id!: number;
  entityId!: string;
  entityRevision!: number;
  schedule!: boolean;
  detail!: SureFlowLoopDetail;

}
